<app-nav-bar></app-nav-bar>
<div style="padding-left: 10%;padding-right: 10%;text-align: center;padding-top: 10px;margin-bottom: 15px;">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>